import React, {
  useContext,
  useEffect,
  useState,
  useCallback,
  useRef,
} from "react";
import AddedPathology from "./AddedPathology/AddedPathology";
import AIPathology from "./AIPathology/AIPathology";
import AnnotationContext from "../../../../context/annotation/AnnotationContext";
import { ScrollMenu } from "react-horizontal-scrolling-menu";
import { LeftArrowFunction, RightArrowFunction } from "../../helper/Arrows";
import usePrevious from "../../helper/usePrevious";
import ViewportContext from "../../../../context/studyviewer/ViewportContext";
import PencilIcon from "../../../../components/SVGComponents/PencilIcon";
import EyeIcon from "../../../../components/SVGComponents/EyeIcon";
import EyeSlashIcon from "../../../../components/SVGComponents/EyeSlashIcon";
import { registerIcons } from '@fluentui/react/lib/Styling';
import studyReportContext from "../../../../context/studyreport/StudyReportContext";
import StackScrollCustom from "../../../../components/SVGComponents/Tools/StackScrollCustom";
import { annotation } from "@cornerstonejs/tools";

registerIcons({
  icons: {
    EditCustomIcon: <PencilIcon />,
    EyeCustomSlashIcon: <EyeSlashIcon />,
    EyeCustomIcon: <EyeIcon />,
    StackScrollCustom: <StackScrollCustom />,
  },
});

const SelectedAnnotationsList = () => {
  const {checkForOptionSubOption,selectAIPathology, annotationState, addOrRemoveAnnotation,setAddedAnnotation,handleUpdateAnnotationState, checkIfAITagLocked } =
    useContext(AnnotationContext);

    const { addedAnnotation,addLockedAIPathology, checkBoundingBoxExistPathalogy, changeAiBbVisibility, handlePencilClick, removeBB} =
    useContext(ViewportContext);


  const {setEnableReportRegenerate} = useContext(studyReportContext);

  // can save and restore position if needed
  const [position, setPosition] = useState(100);

  const restorePosition = useCallback(
    ({ scrollContainer }) => {
      if (scrollContainer.current) {
        scrollContainer.current.scrollLeft = position;
      }
    },
    [position]
  );

  const savePosition = useCallback(
    ({ scrollContainer }) =>
      !!scrollContainer.current &&
      setPosition(scrollContainer.current.scrollLeft),
    []
  );

  function onWheel(apiObj, ev) {
    const isThouchpad = Math.abs(ev.deltaX) !== 0 || Math.abs(ev.deltaY) < 15;

    if (isThouchpad) {
      ev.stopPropagation();
      return;
    }

    if (ev.deltaY < 0) {
      apiObj.scrollNext();
    } else if (ev.deltaY > 0) {
      apiObj.scrollPrev();
    }
  }

  const itemsPrev = usePrevious(addedAnnotation);
  const apiRef = useRef();
  useEffect(() => {
    if (addedAnnotation.length > itemsPrev?.length) {
      apiRef.current?.scrollToItem?.(
        apiRef.current?.getItemElementById(addedAnnotation.slice(-1)?.[0]?.id)
      );
    }
  }, [addedAnnotation, itemsPrev]);

  const setBBVisibleOnHover = (id, state) => {
    let isLocked = checkIfAITagLocked(id);
    if(!isLocked) {
      changeAiBbVisibility(id, state);
    } 
  } 
 

  const handleOnClickAIPathology = (id) => {
    // reset the state as hover action need not be performed once smart tag is locked
    selectAIPathology(id);
   
  }

  const unSelectAIPathology = (id) => {
    setEnableReportRegenerate(true);
    let temp = [];
    temp = addedAnnotation.map((item,ind)=>{
        if(item.id == id){
          if(item.is_locked_check != undefined && item.is_locked_check == true)item.is_locked_check = false;
          if(item.is_locked_check != undefined && item.is_annotated_check == true)item.is_annotated_check = false;
          if(item.is_locked != undefined && item.is_locked == true)item.is_locked = false;
          if(item.is_annotated != undefined && item.is_annotated == true)item.is_annotated = false;
          return item;
        }else{
          return item;
        }
    });

    // register the add event listener
    const item = addedAnnotation.filter(item => item.id == id);
    if(item && item.length > 0) {
      let data = {
        id: item[0].id,
        backgroundColor: item[0].color,
        pathalogyName: item[0].name,
      };
    
      handlePencilClick(data);
    }
    if(addLockedAIPathology(id, false)){
      setAddedAnnotation(temp);
      handleUpdateAnnotationState(id,false);

    }
    
    return true;
  }

  return (
    <>
      {addedAnnotation != undefined && addedAnnotation.length > 0 && (
        <div className="added-pathology-box">
          <ScrollMenu
            LeftArrow={LeftArrowFunction}
            RightArrow={RightArrowFunction}
            onInit={restorePosition}
            onScroll={savePosition}
            onWheel={onWheel}
            apiRef={apiRef}
          >
            {addedAnnotation != undefined &&
              addedAnnotation.map((annotation, index) => {
                if (annotation.isActive) {
                  if((annotation.is_locked == true || annotation.is_annotated==true) ||
                  (annotation.is_locked_check == true || annotation.is_annotated_check==true)
                  ){
                    return (
                      <div key={annotation.id}>
                        <AddedPathology
                          pathalogyName={annotation.name}
                          backgroundColor={annotation.color}
                          aiPercent={annotation.corrPathPrediction}
                          showConfigure={
                            checkForOptionSubOption(annotation.id)
                          }
                          allData={annotation}
                          showWarning={checkBoundingBoxExistPathalogy(annotation.id)}
                          addOrRemoveAnnotation={addOrRemoveAnnotation}
                          id={annotation.id}
                          isAI = {annotation.ai_predicted == 1? true: false}
                          isAIEdited = {annotation.isAIEdited}
                          unSelectAIPathology = {unSelectAIPathology}
                        />
                      </div>
                    );
                  }else{
                       return (
                    <div key={annotation.id}
                    >
                      <AIPathology
                        id={annotation.id}
                        pathalogyName={annotation.name}
                        aiPercent={annotation.corrPathPrediction}
                        addOrRemoveAnnotation={addOrRemoveAnnotation}
                        backgroundColor={annotation.color}
                        setBBVisibleOnHover={setBBVisibleOnHover}
                        removeBB = {removeBB}
                        handleOnClickAIPathology = {handleOnClickAIPathology}
                        isAI = {annotation.ai_predicted == 1? true: false}
                      />
                    </div>
                  );
                  }
                  
                } 
              })}
          </ScrollMenu>
        </div>
      )}
    </>
  );
};

export default SelectedAnnotationsList;
